import { ApiDataAccess } from "../../infrastructure/ApiDataAccess";

export class RuleApiDataAccess {

    constructor() {
        this.dataAccess = new ApiDataAccess('api/rules/engine/');
    }

    processRules(
        width,
        length,
        gusset,
        convertingMethodId,
        tearNotchId,
        tearNotchOffset,
        hangHoleId,
        hangHoleOffset,
        ventId,
        ventOffset,
        zipperId,
        zipperOffset,
        doubleCutId,
        sealWidthId,
        gussetTypeId,
        roundedCornersId,
        qrCodeTypeId)
    {
        var self = this;

        return new Promise(function (resolve, reject) {

            var request = {
                Selections: {
                    PackagingFeatures: {
                        ConvertingMethodId: convertingMethodId,
                        Zipper: zipperId,
                        HangHole: hangHoleId,
                        DoubleCut: doubleCutId,
                        TearNotch: tearNotchId,
                        Vent: ventId,
                        SealWidth: sealWidthId,
                        QrCodeType: qrCodeTypeId,
                        GussetType: gussetTypeId,
                        RoundedCorner: roundedCornersId
                    },
                    ProductFeatures: {
                        AromaIds: [],
                        PackagingSustainabilityIds: [],
                        AggressivenessIds: [],
                        ChildResistanceIds: [],
                        ConsistencyIds: [],
                        EmissionIds: [],
                        LightSensitivityIds: [],
                        MoistureIds: [],
                        ShelfLifetimeIds: [],
                        TemperatureConditionIds: [],
                        SalesChannelIds: []
                    },
                },
                PouchLength: length,
                PouchWidth: width,
                PouchGusset: gusset,
                ZipperLocationOffset: zipperOffset,
                VentLocationOffset: ventOffset,
                TearNotchLocationOffset: tearNotchOffset,
                HangHoleLocationOffset: hangHoleOffset,
                ZipperLocationRelatedToGussetSealOffset: 0,
                CertificateIds: [],
                CertificateTypeIds: [],
                TransparencyIds: [],
                FillTypeIds: [],
                FinishTypeIds: [],
                SealTypeIds: [],
                SealWrapTypeIds: [],
                IndustryIds: []
            };

            self.dataAccess.post(`process`, request)
                .then(res => { resolve(res) })
                .catch(ex => reject(ex));
        });
    }
}